import React from 'react';
import { Button } from './Button';
import { CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function SalesLetter() {
  const bullets = ['50 hacks financieros probados y reales', 'Estrategias para la economía latina', 'Métodos que no requieren sacrificios extremos', 'Sistema paso a paso fácil de seguir', 'Aprende a rastrear tus gastos sin estrés', 'Crea un plan financiero sostenible', 'Acceso inmediato en formato PDF', '2 bonos digitales completamente GRATIS'];
  return <section className="w-full py-20 bg-navy-900 text-white" data-id="element-236">
      <div className="max-w-4xl mx-auto px-6" data-id="element-237">
        <div className="space-y-8" data-id="element-238">
          {/* Big Promise */}
          <div className="text-center space-y-4" data-id="element-239">
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight" data-id="element-240">
              🔥 La Verdad Que Nadie Te Dijo
            </h2>
            <p className="text-xl text-gray-300" data-id="element-241">
              La libertad financiera no empieza invirtiendo millones...
            </p>
          </div>

          {/* Storytelling */}
          <div className="space-y-6 text-lg leading-relaxed text-gray-200" data-id="element-242">
            <p data-id="element-243">
              <strong className="text-emerald-400" data-id="element-244">Déjame adivinar...</strong>{' '}
              Llega la quincena y ya sabes que no va a alcanzar. Pagas las
              cuentas, compras lo básico, y de repente... ya no queda nada.
            </p>

            <p data-id="element-245">
              Vives contando cada peso. Te estresas cada vez que surge un gasto
              inesperado. Y lo peor: sientes que por más que trabajas, nunca
              avanzas.
            </p>

            <p data-id="element-246">
              Quieres ahorrar. Quieres invertir. Quieres tener estabilidad. Pero
              no sabes por dónde empezar.
            </p>

            <p className="text-xl font-bold text-emerald-400" data-id="element-247">
              Y aquí está la verdad que cambia todo:
            </p>

            <p data-id="element-248">
              <strong className="text-emerald-400" data-id="element-249">
                La libertad financiera no empieza invirtiendo millones.
              </strong>{' '}
              Empieza cuando aprendes a manejar tu quincena.
            </p>

            <p data-id="element-250">
              Cuando sabes exactamente cuánto tienes. Cuando tomas decisiones
              con intención. Cuando dejas de vivir en modo emergencia.
            </p>
          </div>

          {/* Vision Block */}
          <div className="bg-gradient-to-r from-emerald-900/50 to-cyan-900/50 rounded-3xl p-8 space-y-6" data-id="element-251">
            <h3 className="font-serif text-3xl text-center" data-id="element-252">
              🌱 Esto No Es Solo Sobrevivir
            </h3>

            <p className="text-lg text-gray-200 text-center" data-id="element-253">
              Es el comienzo de tu libertad financiera.
            </p>

            <div className="space-y-4 text-gray-200" data-id="element-254">
              <p data-id="element-255">
                Aprender a manejar tu quincena no es pequeño. Es el primer paso
                que todas las personas con estabilidad financiera dieron, aunque
                nadie lo diga.
              </p>

              <p className="font-bold text-emerald-400" data-id="element-256">
                La libertad financiera empieza cuando:
              </p>

              <ul className="space-y-3 pl-6" data-id="element-257">
                <li className="flex items-start gap-3" data-id="element-258">
                  <span className="text-emerald-400 mt-1" data-id="element-259">•</span>
                  <span data-id="element-260">Sabes exactamente cuánto tienes</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-261">
                  <span className="text-emerald-400 mt-1" data-id="element-262">•</span>
                  <span data-id="element-263">Tomas decisiones con intención</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-264">
                  <span className="text-emerald-400 mt-1" data-id="element-265">•</span>
                  <span data-id="element-266">Dejas de vivir en modo emergencia</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-267">
                  <span className="text-emerald-400 mt-1" data-id="element-268">•</span>
                  <span data-id="element-269">Construyes hábitos que se sostienen en el tiempo</span>
                </li>
              </ul>

              <p className="text-lg pt-4" data-id="element-270">
                👉 Las oportunidades de riqueza siempre han estado ahí. Lo que
                faltaba era un plan, una guía y la mentalidad correcta para
                llegar a ellas.
              </p>

              <p className="text-xl font-bold text-center text-emerald-400" data-id="element-271">
                Y eso… se construye desde aquí.
              </p>
            </div>
          </div>

          {/* Mental Reframe */}
          <div className="space-y-6 text-lg text-gray-200" data-id="element-272">
            <h3 className="font-serif text-3xl text-center text-white" data-id="element-273">
              🧠 No Se Trata Solo de Dinero
            </h3>

            <p className="text-center text-xl" data-id="element-274">
              Se trata de convertirte en la mujer que sabe manejarlo.
            </p>

            <p data-id="element-275">Cuando aprendes a manejar tu quincena:</p>

            <ul className="space-y-3 pl-6" data-id="element-276">
              <li className="flex items-start gap-3" data-id="element-277">
                <span className="text-emerald-400 mt-1" data-id="element-278">✓</span>
                <span data-id="element-279">Dejas de reaccionar</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-280">
                <span className="text-emerald-400 mt-1" data-id="element-281">✓</span>
                <span data-id="element-282">Empiezas a elegir</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-283">
                <span className="text-emerald-400 mt-1" data-id="element-284">✓</span>
                <span data-id="element-285">Ganas claridad</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-286">
                <span className="text-emerald-400 mt-1" data-id="element-287">✓</span>
                <span data-id="element-288">Construyes confianza</span>
              </li>
            </ul>

            <p className="text-xl font-bold text-center" data-id="element-289">Y desde ese lugar:</p>

            <ul className="space-y-3 pl-6" data-id="element-290">
              <li className="flex items-start gap-3" data-id="element-291">
                <span className="text-cyan-400 mt-1" data-id="element-292">→</span>
                <span data-id="element-293">Ahorrar es posible</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-294">
                <span className="text-cyan-400 mt-1" data-id="element-295">→</span>
                <span data-id="element-296">Invertir deja de dar miedo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-297">
                <span className="text-cyan-400 mt-1" data-id="element-298">→</span>
                <span data-id="element-299">Soñar en grande ya no se siente ridículo</span>
              </li>
            </ul>

            <p className="text-2xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400" data-id="element-300">
              💡 La riqueza no se alcanza desde el caos. Se construye desde el
              orden.
            </p>
          </div>

          {/* What You Get */}
          <div className="bg-white/10 rounded-3xl p-8" data-id="element-301">
            <h3 className="font-serif text-2xl mb-6 text-center" data-id="element-302">
              📘 Este libro es:
            </h3>
            <div className="space-y-4 text-gray-200" data-id="element-303">
              <p className="flex items-start gap-3" data-id="element-304">
                <span className="text-emerald-400 mt-1" data-id="element-305">✓</span>
                <span data-id="element-306">El inicio de tu educación financiera real</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-307">
                <span className="text-emerald-400 mt-1" data-id="element-308">✓</span>
                <span data-id="element-309">La base sobre la que se construye todo lo demás</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-310">
                <span className="text-emerald-400 mt-1" data-id="element-311">✓</span>
                <span data-id="element-312">
                  El punto donde dejas de sobrevivir… y empiezas a avanzar
                </span>
              </p>
            </div>
          </div>

          {/* Bullets */}
          <div className="bg-white/10 rounded-3xl p-8" data-id="element-313">
            <h3 className="font-serif text-2xl mb-6 text-center" data-id="element-314">
              Con esta oferta vas a recibir:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-315">
              {bullets.map((bullet, index) => <div key={index} className="flex items-start gap-3" data-id="element-316">
                  <CheckCircleIcon className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-1" data-id="element-317" />
                  <span className="text-gray-200" data-id="element-318">{bullet}</span>
                </div>)}
            </div>
          </div>

          {/* Final Vision */}
          <div className="text-center space-y-6 bg-gradient-to-r from-emerald-900/30 to-cyan-900/30 rounded-3xl p-8" data-id="element-319">
            <h3 className="font-serif text-3xl text-white" data-id="element-320">
              🔥 Este Es El Comienzo
            </h3>
            <p className="text-xl text-gray-200" data-id="element-321">
              El comienzo de tomar el control. El comienzo de abrir espacio para
              oportunidades. El comienzo de construir riqueza con intención, no
              con suerte.
            </p>
            <p className="text-lg text-gray-300" data-id="element-322">
              No necesitas saberlo todo hoy. No necesitas ser perfecta.
            </p>
            <p className="text-xl font-bold text-emerald-400" data-id="element-323">
              👉 Solo necesitas empezar.
            </p>
            <p className="text-gray-200" data-id="element-324">
              Y empezar con una guía clara, hecha para tu realidad, es la
              decisión más inteligente que puedes tomar ahora.
            </p>
            <Button size="lg" href={CHECKOUT_URL} data-id="element-325">
              Sí, quiero empezar mi camino hacia la libertad financiera
            </Button>
          </div>
        </div>
      </div>
    </section>;
}